module.exports = __webpack_public_path__ + "static/media/aicra.3985b057.jpg";